import { ensureBugsnagStarted } from "~/utils/bugsnag";
import { useLoaderData } from "@remix-run/react";
import { useEffect } from "react";
import { type RootLoaderData } from "~/root";

import type { Dict } from "mixpanel-browser";
import mixpanel from "mixpanel-browser";

let tracking: TrackingActions;

export default function useTracking() {
  const { userData, mixpanelToken } = useLoaderData<RootLoaderData>() || {};

  tracking = tracking ?? getTracker(mixpanelToken);

  useEffect(() => {
    if (userData?.provider_uuid) {
      tracking.register({
        id: userData.provider_uuid,
      });
    }

    if (userData?.email) {
      tracking.identify(userData.email);
      tracking.people.set({ $email: userData.email });
    }
  }, [userData]);

  return tracking;
}

type TrackingActions = {
  init: (token: string) => void;
  identify: (id: string) => void;
  alias: (id: string) => void;
  track: (name: string, props?: Dict) => void;
  track_pageview: (args?: Record<any, any>) => void;
  register: (props: Dict) => void;
  people: {
    set: (props: Dict) => void;
  };
  reset: () => void;
};
const getTracker = (token: string) => {
  if (!token) {
    ensureBugsnagStarted();
    mixpanel.init("DO_NOT_INIT_MIXPANEL");
  } else {
    mixpanel.init(token);
  }

  return mixpanel;
};
